import { useState } from "react";

import { MagicFilled } from "@aircall/icons";
import { Button, Icon, Spacer } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { BannerProps } from "./AiPromotionalBanner.decl";

import { FeatureBanner } from "@/components/FeatureBanner";
import { useCall } from "@/hooks/useCall/useCall";
import { useShouldDisplayPromotionalBanner } from "@/hooks/useShouldDisplayPromotionalBanner/useShouldDisplayPromotionalBanner";
import { useTrackBanner } from "@/hooks/useTrackBanner/useTrackBanner";
import { ButtonLink } from "../ButtonLink/ButtonLink";

export function AiPromotionalBanner({ direction, alignItems }: BannerProps) {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const { handleClick } = useTrackBanner();
  const { call } = useCall();

  const shouldBeNotifiedForAiPackage = useShouldDisplayPromotionalBanner();

  if (
    !isVisible ||
    !shouldBeNotifiedForAiPackage ||
    call?.type === "voicemail"
  ) {
    return null;
  }

  const hideOnClick = () => {
    setIsVisible(false);
  };

  return (
    <FeatureBanner
      fluid
      content={t("ai.banner.content")}
      icon={<Icon component={MagicFilled} color="#004736" size={24} />}
      direction={direction}
      alignItems={alignItems}
    >
      <Spacer space="s" alignItems="center">
        <Button
          variant="secondary"
          onClick={hideOnClick}
          mode="link"
          size="small"
        >
          {t("close")}
        </Button>
        <ButtonLink
          onClick={handleClick}
          href={t("ai.banner.href")}
          target="_blank"
          size="small"
        >
          {t("ai.banner.button")}
        </ButtonLink>
      </Spacer>
    </FeatureBanner>
  );
}
